import type { PiletApi } from '@chess/platform-web';
// The global styles: the Nocturne design system's tokens and component
// classes, exported from Claude Design (docs/design/_ds in v1), and the
// app-level rules on top of them. Loading this plugin styles the app;
// every other plugin takes its colors, fonts, spacing and radii from the
// tokens and defines no values of its own.
import './nocturne.css';
// The highlight colours (results, score change, grades, time classes,
// ending cases), on :root: every highlight colour in the app.
import './colors.css';
import './theme.css';

export function setup(_app: PiletApi) {}
